module.exports = __webpack_public_path__ + "img/galleta.74a7ffd6.png";